// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3mRGj","list":"styles_list__31Zp-"};